// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");

function makeRefetchVariables(param) {
  
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

var responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/)
  ],
  "type": "PropertyLocationWithHiddenAddress",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v6/*: any*/),
    (v1/*: any*/),
    {
      "alias": "agentProfilePhoto",
      "args": null,
      "concreteType": "ProfilePhoto",
      "kind": "LinkedField",
      "name": "profilePhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "ratio",
              "variableName": "__relay_internal__pv__DevicePixelRatio"
            },
            {
              "kind": "Literal",
              "name": "width",
              "value": 60
            }
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "agentV2",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isForSalePropertyAgent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v7/*: any*/)
      ],
      "type": "VisibleForSalePropertyAgent",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v11 = [
  (v7/*: any*/),
  (v1/*: any*/)
],
v12 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientContactsConnection",
        "kind": "LinkedField",
        "name": "contacts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientContactsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientContactV5",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ClientV5",
    "abstractKey": "__isClientV5"
  },
  (v1/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "propertyLocation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v4/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v5/*: any*/)
          ],
          "type": "PropertyLocationWithVisibleAddress",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForForSalePropertyV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ForSalePropertyV5",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ForSalePropertyV5",
  "kind": "LinkedField",
  "name": "source",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v13/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForForSalePropertyV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v16/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v18 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForForSalePropertyV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v16/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "BuyerNeedV5",
  "kind": "LinkedField",
  "name": "source",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Buyer",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForBuyerNeedV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v19/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v21 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForBuyerNeedV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v19/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Landlord",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "RentalPropertyV5",
  "kind": "LinkedField",
  "name": "source",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v22/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "RentalNeedV5",
  "kind": "LinkedField",
  "name": "source",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Renter",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForRentalNeedV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v24/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
],
v26 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MatchForRentalNeedV5",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v24/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeDashboardPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ClientStatsWidget_query"
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "limit",
            "value": 5
          }
        ],
        "kind": "FragmentSpread",
        "name": "NotificationWidgetRelay_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "HomeDashboardPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountClientStats",
        "kind": "LinkedField",
        "name": "clientStatsForCurrentAccountV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "buyers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sellers",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 5
          }
        ],
        "concreteType": "QueryNotificationsForCurrentUserV5Connection",
        "kind": "LinkedField",
        "name": "notificationsForCurrentUserV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueryNotificationsForCurrentUserV5ConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isNotificationV5"
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShowingV5",
                        "kind": "LinkedField",
                        "name": "showing",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDateV2",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDateV2",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ForSalePropertyV5",
                            "kind": "LinkedField",
                            "name": "property",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "propertyLocation",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v3/*: any*/),
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "visibilityRule",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PropertyLocationWithVisibleAddress",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              (v1/*: any*/),
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v0/*: any*/)
                                ],
                                "type": "PropertyV5",
                                "abstractKey": "__isPropertyV5"
                              }
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "UpcomingShowingNotification",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DraftV5",
                        "kind": "LinkedField",
                        "name": "draft",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "origin",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "publishedProperty",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v2/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DraftPropertyV5",
                            "kind": "LinkedField",
                            "name": "draftProperty",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Area",
                                "kind": "LinkedField",
                                "name": "userSelectedArea",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "UnfinishedDraftNotification",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "agentMatchLog",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "agentMatchLogByType",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "agentMatchLog",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuyerNeedV5",
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BroadcastBuyerNeedCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BroadcastBuyerNeedCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v15/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BroadcastBuyerNeedCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BuyerNeedEditedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BuyerNeedEditedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v17/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BuyerNeedEditedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BuyerNeedEditedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v18/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BuyerNeedEditedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietBuyerNeedBroadcastedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietBuyerNeedBroadcastedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v17/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietBuyerNeedBroadcastedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietBuyerNeedBroadcastedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v18/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "QuietBuyerNeedBroadcastedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietBuyerNeedCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietBuyerNeedCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v15/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "QuietBuyerNeedCreatedAMLEvent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "BuyerNeedAgentMatchLogV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ForSalePropertyV5",
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BroadcastPropertyCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BroadcastPropertyCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BroadcastPropertyCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietPropertyCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietPropertyCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "QuietPropertyCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyEditedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyEditedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v21/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyEditedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyEditedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ForSalePropertyEditedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyRebroadcastedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyRebroadcastedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v21/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyRebroadcastedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyRebroadcastedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ForSalePropertyRebroadcastedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietPropertyBroadcastedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietPropertyBroadcastedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v21/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "QuietPropertyBroadcastedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "QuietPropertyBroadcastedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "QuietPropertyBroadcastedAMLEvent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ForSalePropertyAgentMatchLogV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalNeedV5",
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalNeedCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalNeedCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MatchForRentalPropertyV5",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "RentalPropertyV5",
                                                    "kind": "LinkedField",
                                                    "name": "source",
                                                    "plural": false,
                                                    "selections": [
                                                      (v22/*: any*/),
                                                      (v14/*: any*/),
                                                      (v1/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v1/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalNeedCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalNeedEditedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalNeedEditedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MatchForRentalPropertyV5",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v23/*: any*/),
                                                  (v1/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalNeedEditedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalNeedEditedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MatchForRentalPropertyV5",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v23/*: any*/),
                                                  (v1/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalNeedEditedAMLEvent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RentalNeedAgentMatchLogV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalPropertyV5",
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyCreatedAMLEventMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "matches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyCreatedAMLEventMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalPropertyCreatedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyEditedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyEditedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v26/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyEditedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyEditedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalPropertyEditedAMLEvent",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyRebroadcastedAMLEventExistingMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "existingMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyRebroadcastedAMLEventExistingMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v26/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyRebroadcastedAMLEventNewMatchesConnection",
                                        "kind": "LinkedField",
                                        "name": "newMatches",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyRebroadcastedAMLEventNewMatchesConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": (v25/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RentalPropertyRebroadcastedAMLEvent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RentalPropertyAgentMatchLogV5",
                            "abstractKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AgentMatchLogNotification",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "notificationsForCurrentUserV5(first:5)"
      }
    ]
  },
  "params": {
    "cacheID": "7871f98320958c28b862d00451c9b32f",
    "id": null,
    "metadata": {},
    "name": "HomeDashboardPageQuery",
    "operationKind": "query",
    "text": "query HomeDashboardPageQuery(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...ClientStatsWidget_query\n  ...NotificationWidgetRelay_query_w479I\n}\n\nfragment AgentProfilePhoto_agent on Agent {\n  displayName\n  agentProfilePhoto: profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment ClientStatsWidget_query on Query {\n  clientStatsForCurrentAccountV5 {\n    buyers\n    sellers\n  }\n}\n\nfragment NotificationWidgetItemSource_notification on NotificationV5 {\n  __isNotificationV5: __typename\n  __typename\n  ... on UpcomingShowingNotification {\n    showing {\n      ...NotificationWidgetTexts_showing\n      property {\n        id\n        agentV2 {\n          __typename\n          ... on VisibleForSalePropertyAgent {\n            agent {\n              ...AgentProfilePhoto_agent\n              nodeId\n            }\n          }\n        }\n        nodeId\n      }\n      nodeId\n    }\n  }\n  ... on UnfinishedDraftNotification {\n    draft {\n      databaseId\n      origin\n      publishedProperty {\n        __typename\n        id\n        nodeId\n      }\n      draftProperty {\n        address\n        userSelectedArea {\n          name\n          nodeId\n        }\n      }\n      nodeId\n    }\n  }\n  ... on AgentMatchLogNotification {\n    agentMatchLog {\n      __typename\n      databaseId\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n    agentMatchLogByType: agentMatchLog {\n      __typename\n      ... on BuyerNeedAgentMatchLogV5 {\n        ...NotificationWidgetTextsBuyerNeed_aml\n        source {\n          agent {\n            ...AgentProfilePhoto_agent\n            nodeId\n          }\n          nodeId\n        }\n      }\n      ... on ForSalePropertyAgentMatchLogV5 {\n        ...NotificationWidgetTextsForSaleProperty_aml\n        source {\n          agentV2 {\n            __typename\n            ... on VisibleForSalePropertyAgent {\n              agent {\n                ...AgentProfilePhoto_agent\n                nodeId\n              }\n            }\n          }\n          nodeId\n        }\n      }\n      ... on RentalNeedAgentMatchLogV5 {\n        ...NotificationWidgetTextsRentalNeed_aml\n        source {\n          agent {\n            ...AgentProfilePhoto_agent\n            nodeId\n          }\n          nodeId\n        }\n      }\n      ... on RentalPropertyAgentMatchLogV5 {\n        ...NotificationWidgetTextsRentalProperty_aml\n        source {\n          agent {\n            ...AgentProfilePhoto_agent\n            nodeId\n          }\n          nodeId\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment NotificationWidgetItem_notification on NotificationV5 {\n  __isNotificationV5: __typename\n  __typename\n  id\n  status\n  ...NotificationWidgetItemSource_notification\n}\n\nfragment NotificationWidgetRelay_query_w479I on Query {\n  notificationsForCurrentUserV5(first: 5) {\n    edges {\n      node {\n        __typename\n        nodeId\n        createdAt\n        ...NotificationWidgetItem_notification\n      }\n    }\n  }\n}\n\nfragment NotificationWidgetTextsAgent_agent on Agent {\n  id\n  displayName\n}\n\nfragment NotificationWidgetTextsAgent_agentId on Agent {\n  id\n}\n\nfragment NotificationWidgetTextsBuyerNeed_aml on BuyerNeedAgentMatchLogV5 {\n  source {\n    agent {\n      ...NotificationWidgetTextsAgent_agent\n      nodeId\n    }\n    nodeId\n  }\n  event {\n    __typename\n    ... on BroadcastBuyerNeedCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              ...NotificationWidgetTextsPropertyLocationLabel_property\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on BuyerNeedEditedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              ...NotificationWidgetTextsPropertyLocationLabel_property\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              ...NotificationWidgetTextsPropertyLocationLabel_property\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on QuietBuyerNeedBroadcastedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              ...NotificationWidgetTextsPropertyLocationLabel_property\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              ...NotificationWidgetTextsPropertyLocationLabel_property\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on QuietBuyerNeedCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              ...NotificationWidgetTextsPropertyLocationLabel_property\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NotificationWidgetTextsClientLabel_client on ClientV5 {\n  __isClientV5: __typename\n  __typename\n  contacts {\n    edges {\n      node {\n        displayName\n        nodeId\n      }\n    }\n  }\n}\n\nfragment NotificationWidgetTextsForSaleProperty_aml on ForSalePropertyAgentMatchLogV5 {\n  source {\n    agentV2 {\n      __typename\n      ...NotificationWidgetTextsForSale_agent\n      ...NotificationWidgetTextsForSale_agentId\n    }\n    nodeId\n  }\n  event {\n    __typename\n    ... on BroadcastPropertyCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on QuietPropertyCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on ForSalePropertyEditedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on ForSalePropertyRebroadcastedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on QuietPropertyBroadcastedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NotificationWidgetTextsForSale_agent on ForSalePropertyAgent {\n  __isForSalePropertyAgent: __typename\n  __typename\n  ... on VisibleForSalePropertyAgent {\n    agent {\n      ...NotificationWidgetTextsAgent_agent\n      nodeId\n    }\n  }\n  ... on AnonymousForSalePropertyAgent {\n    __typename\n  }\n}\n\nfragment NotificationWidgetTextsForSale_agentId on ForSalePropertyAgent {\n  __isForSalePropertyAgent: __typename\n  __typename\n  ... on VisibleForSalePropertyAgent {\n    agent {\n      id\n      nodeId\n    }\n  }\n}\n\nfragment NotificationWidgetTextsPropertyLocationLabel_property on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      address\n    }\n  }\n}\n\nfragment NotificationWidgetTextsRentalNeed_aml on RentalNeedAgentMatchLogV5 {\n  source {\n    agent {\n      ...NotificationWidgetTextsAgent_agent\n      nodeId\n    }\n    nodeId\n  }\n  event {\n    __typename\n    ... on RentalNeedCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              ...NotificationWidgetTextsPropertyLocationLabel_property\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on RentalNeedEditedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              ...NotificationWidgetTextsPropertyLocationLabel_property\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              ...NotificationWidgetTextsPropertyLocationLabel_property\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NotificationWidgetTextsRentalProperty_aml on RentalPropertyAgentMatchLogV5 {\n  source {\n    agent {\n      ...NotificationWidgetTextsAgent_agent\n      ...NotificationWidgetTextsAgent_agentId\n      nodeId\n    }\n    nodeId\n  }\n  event {\n    __typename\n    ... on RentalPropertyCreatedAMLEvent {\n      matches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on RentalPropertyEditedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n    ... on RentalPropertyRebroadcastedAMLEvent {\n      existingMatches {\n        edges {\n          node {\n            id\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n      newMatches {\n        edges {\n          node {\n            source {\n              client {\n                ...NotificationWidgetTextsClientLabel_client\n                nodeId\n              }\n              nodeId\n            }\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NotificationWidgetTexts_showing on ShowingV5 {\n  startDateV2\n  endDateV2\n  property {\n    ...NotificationWidgetTextsPropertyLocationLabel_property\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithHiddenAddress {\n        locationDisplay\n      }\n      ... on PropertyLocationWithVisibleAddress {\n        locationDisplay\n        address\n        visibilityRule\n      }\n    }\n    agentV2 {\n      __typename\n      ...NotificationWidgetTextsForSale_agent\n      ...NotificationWidgetTextsForSale_agentId\n    }\n    nodeId\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

var include = RescriptRelay.MakeLoadQuery({
      query: node,
      convertVariables: convertVariables
    });

var load = include.load;

var queryRefToObservable = include.queryRefToObservable;

var queryRefToPromise = include.queryRefToPromise;

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
